import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);
const LANGS = ["en", "sw", "pl", "fr", "zh"];

const initialLang = () => {
  const fromUrl = new URLSearchParams(window.location.search).get("lang");
  if (LANGS.includes(fromUrl)) return fromUrl;
  const stored = window.localStorage.getItem("margtor-lang");
  return LANGS.includes(stored) ? stored : "en";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(initialLang);
  const toggle = useCallback(() => setLang((l) => LANGS[(LANGS.indexOf(l) + 1) % LANGS.length]), []);

  useEffect(() => {
    window.localStorage.setItem("margtor-lang", lang);
  }, [lang]);

  const t = translations[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
